export default __webpack_public_path__ + "static/media/App_Store.ac387f64.svg";